import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { TooltipProvider } from "./components/ui/tooltip";
import "./shared/i18n";
import "./integrations/firebase/emulator-test-auth";
import { initialiseLaunchDarkly } from "./integrations/launch-darkly";
import { installClientErrorSink } from "./shared/services/installClientErrorSink";

// Before the first render, so a fault during startup is still reported.
installClientErrorSink();

const root = ReactDOM.createRoot(document.getElementById("root")!);

const load = async () => {
  const LaunchDarklyProvider = await initialiseLaunchDarkly();

  root.render(
    <React.StrictMode>
      <LaunchDarklyProvider>
        <TooltipProvider delayDuration={100}>
          <App />
        </TooltipProvider>
      </LaunchDarklyProvider>
    </React.StrictMode>,
  );
};

load().then();
